import { Tag } from "@design-system/Tag/Tag";

import { formatEventClassLabel } from "@utils/activityClassificationLabels";

type Props = {
  eventClass?: string | null;
  compact?: boolean;
};

export const EventClassTag = ({ eventClass, compact }: Props) => {
  const label = formatEventClassLabel(eventClass);
  if (!label) {
    return null;
  }

  return <Tag color="secondary" text={label} noWrap compact={compact} />;
};
